import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./style.scss";

interface HeaderProps {
    title?: string;
    subtitle?: string;
    onBack?: () => void;
    showBack?: boolean;
    backText?: string;
}

const Header = (props: HeaderProps) => {
    return (
        <div className="vapor-header">
            <div
                className="vapor-header-back"
                onClick={() => {
                    if (props.onBack) {
                        props.onBack();
                    }
                }}
            >
                {props.showBack ? (
                    <>
                        {<FontAwesomeIcon icon={["far", "arrow-left"]} />}
                        {props.backText}
                    </>
                ) : (
                    <>&nbsp;</>
                )}
            </div>
            <div className="vapor-header-title">
                <div>{props.title}</div>
                <div>{props.subtitle}</div>
            </div>
            <div className="vapor-header-right">&nbsp;</div>
        </div>
    );
};

Header.defaultProps = {
    showBack: false,
};

export default Header;
